/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var App, Highcharts, Provider, React, ReactDOM, Redux, app, cardActions, gameActions, host, initialState, io, loader, rootReducer, socket, socket_connection, storage, store, up, userActions;

React = require('react');

ReactDOM = require('react-dom');

io = require('socket.io-client');

Highcharts = require('highcharts-browserify');

window.app = app = {};

Provider = require('react-redux').Provider;

Redux = require('redux');

App = require('./app');

cardActions = require('./actions/cards');

userActions = require('./actions/user');

gameActions = require('./actions/games');

rootReducer = require('./reducers');

app.store = store = Redux.createStore(rootReducer, initialState = void 0);

if (module.hot) {
  module.hot.accept('./reducers', function() {
    var nextReducer;
    nextReducer = require('./reducers');
    return store.replaceReducer(nextReducer);
  });
}

JSON.safeParse = function(data) {
  var e, error;
  try {
    return JSON.parse(data);
  } catch (error) {
    e = error;
    return null;
  }
};

storage = window.sessionStorage;

app.socket = {};

host = window.location.host;

socket_connection = host;

if (host.includes('localhost')) {
  socket_connection = 'http://localhost:3001';
} else if (host.includes('192.168.0.224')) {
  socket_connection = 'http://192.168.0.224:3001';
}

console.log(socket_connection);

app.socket = socket = io(socket_connection, {
  'reconnectionAttempts': 3,
  'path': '/socket.io/'
});

socket.on('connect', function() {
  var session;
  console.log('Socket.io: connected to server');
  store.dispatch(cardActions.requestCards());
  store.dispatch(gameActions.requestGames());
  if (session = storage.getItem('session')) {
    loader.user = false;
    return store.dispatch(userActions.sessionLogin(session));
  }
});

loader = {
  cards: false,
  games: false,
  user: true,
  isLoaded: function() {
    return this.cards && this.games && this.user;
  }
};

socket.on('reconnect_failed', function() {
  return store.dispatch(userActions.failedLogin('Spojení ztraceno'));
});

socket.on('data', function(msg) {
  var data;
  if ((msg != null ? msg.endpoint : void 0) === '/cards/list') {
    store.dispatch(cardActions.receiveCards(JSON.safeParse(msg.value)));
    loader.cards = true;
    up();
  }
  if ((msg != null ? msg.endpoint : void 0) === '/games/list') {
    data = JSON.safeParse(msg.value);
    store.dispatch(gameActions.receiveGames(data.gameList));
    loader.games = true;
    up();
  }
  if ((msg != null ? msg.endpoint : void 0) === '/games/create' || (msg != null ? msg.endpoint : void 0) === '/games/join' || (msg != null ? msg.endpoint : void 0) === '/games/leave') {
    data = JSON.safeParse(msg.value);
    store.dispatch(userActions.joinedGame(data.gameId));
  }
  if ((msg != null ? msg.endpoint : void 0) === '/games/ready' || (msg != null ? msg.endpoint : void 0) === '/games/start') {
    data = JSON.safeParse(msg.value);
  }
  if ((msg != null ? msg.endpoint : void 0) === '/user/login') {
    data = JSON.safeParse(msg.value);
    if (!data || data.error) {
      store.dispatch(userActions.failedLogin(data != null ? data.error : void 0));
      return;
    }
    storage.setItem('session', data.session);
    store.dispatch(userActions.receiveUser(data));
  }
  if ((msg != null ? msg.endpoint : void 0) === '/user/sessionLogin') {
    data = JSON.safeParse(msg.value);
    if (!data || data.error) {
      storage.removeItem('session');
      store.dispatch(userActions.failedLogin(data != null ? data.error : void 0));
    } else {
      store.dispatch(userActions.receiveUser(data));
    }
    loader.user = true;
    up();
  }
  if ((msg != null ? msg.endpoint : void 0) === '/user/logout') {
    storage.removeItem('session');
    return store.dispatch(userActions.loggedOut());
  }
});

up = function() {
  var main;
  if (loader.isLoaded()) {
    main = document.querySelector('#content');
    if (!main) {
      throw new Error('No main element');
    }
    return ReactDOM.render(React.createElement(Provider, {
      "store": store
    }, React.createElement(App, null)), main);
  }
};


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "main-redux.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/main-redux.cjsx
 ** module id = 1
 ** module chunks = 0
 **/